import React, { ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';
import { joinClassNames } from '../../../../utils/commonUtils';

interface ImageButtonProps {
  icon: ReactNode;
  tooltip: string;
  onClickHandler: () => void;
  active?: boolean;
}

export const ImageButton = ({ icon, tooltip, onClickHandler, active }: ImageButtonProps) => (
  <>
    <Tooltip id='image-button-tooltip' delayShow={1000} delayHide={500} />
    <button
      data-testid='image-button'
      data-tooltip-id='image-button-tooltip'
      data-tooltip-content={tooltip}
      type='button'
      className={joinClassNames('btn pop', active ? 'active' : 'cursor-default')}
      onClick={() => active && onClickHandler()}
    >
      {icon}
    </button>
  </>
);
